// TranslationContext.js
import React, { createContext, useEffect, useState } from "react";
import { useGetRequest } from "../Client/index.js";

export const TranslationContext = createContext();

export function TranslationProvider({ children }) {
  const [languageCode, setLanguageCode] = useState("EN");

  const [translations, setTranslations] = useState(null);

  const { status, data } = useGetRequest(
    `api/v2-label-portal-translations.php?language=${languageCode}`,
    {}
  );

  useEffect(() => {
    if (status === "fetched") {
      setTranslations(data);
    }
  }, [status, data]);

  return (
    <TranslationContext.Provider
      value={{ data, status, setLanguageCode, languageCode }}
    >
      {children}
    </TranslationContext.Provider>
  );
}
